'use strict';

var _ = require('lodash');
var DemandPostingContextService = function DemandPostingContextService(seasonLabelFormattingService) {
  function getDateRangesFromBrush(dataRetriever) {
    return _.chain(dataRetriever.getFilters()).filter({
      filterType: 'dateRange'
    }).map(function (filter) {
      return filter.filterArguments[0];
    }).flatten().value();
  }
  function getContext(gridData) {
    var tmpMap = {
      seasons: {},
      markets: [],
      poses: [],
      classGroups: [],
      departureDates: []
    };
    return _.chain(gridData).reduce(function (result, item) {
      var seasonValue = item.seasonOverride || item.season;
      result.seasons[seasonValue] = true;
      result.markets.push(item.market);
      result.poses.push(item.posName);
      result.classGroups.push(item.classGroup);
      result.departureDates.push(item.departureDateMoment);
      return result;
    }, tmpMap).mapValues(function (item, key) {
      var values = key === 'seasons' ? seasonLabelFormattingService.formatSeasonLabels(_.keys(item)) : item;
      return _.chain(values).uniqBy().sortBy().value();
    }).value();
  }
  function dateToRange(departureDate) {
    return [{
      from: departureDate,
      to: departureDate
    }];
  }
  function getDateRange(context, dataRetriever) {
    return context.departureDates.length === 1 ? dateToRange(context.departureDates[0]) : getDateRangesFromBrush(dataRetriever);
  }
  return {
    getContext: getContext,
    getDateRange: getDateRange
  };
};
DemandPostingContextService.$inject = ['SeasonLabelFormattingService'];
module.exports = DemandPostingContextService;